import {JobResult, JobResultType} from '../jobs.types';
import {Routes} from 'common/src/modules/routing/routing.config';
import {BGProcessLink, BGProcessLinkType} from '../../backgroundProcess/backgroundProcess.types';
import getFileNameFromUrl from 'common/src/utils/urlUtils/getFileNameFromUrl';

function getJobLink(jobResult?: JobResult): BGProcessLink {
  if (!jobResult) return null;

  switch (jobResult.type) {
    case JobResultType.Template:
      return {
        label: 'Go to Template',
        type: BGProcessLinkType.Href,
        value: {
          url: Routes.TemplateWorkflow,
          pathParams: {templateId: jobResult.id},
        },
      };
    case JobResultType.Creative:
      return {
        label: 'Go to Creative',
        type: BGProcessLinkType.Href,
        value: {
          url: Routes.CreativeDynamicParameters,
          pathParams: {creativeId: jobResult.id},
        },
      };
    case JobResultType.FeedInventory:
      return {
        label: 'Check feed items',
        type: BGProcessLinkType.Href,
        value: {
          url: Routes.ProductFeed,
          pathParams: {feedId: jobResult.id},
          queryParams: {tabId: 'Products'},
        },
      };
    case JobResultType.ExportFeedItems:
      return {
        label: 'Download Excel',
        type: BGProcessLinkType.Download,
        value: jobResult.url,
        fileName: jobResult.fileName,
      };

    case JobResultType.LocationFeed:
      return {
        label: 'Check feed items',
        type: BGProcessLinkType.Href,
        value: {
          url: Routes.LocationFeed,
          pathParams: {feedId: jobResult.id},
          queryParams: {tabId: 'table-map'},
        },
      };
    case JobResultType.DownloadMedia:
      return {
        label: 'Download Media',
        type: BGProcessLinkType.Download,
        value: jobResult.url,
      };
    case JobResultType.Tearsheet:
      return {
        label: 'Go to Tearsheet',
        type: BGProcessLinkType.Href,
        value: {
          url: Routes.CampaignTearSheetPreview,
          pathParams: {
            tearsheetId: jobResult.id,
            campaignId: jobResult.campaignId,
            versionId: jobResult.versionId,
          },

          queryParams: {
            campaignType: jobResult.campaignType,
            campaignSubType: jobResult.campaignSubType,
          },
        },
      };
    case JobResultType.Widget:
      return {
        label: 'Go to Widget',
        type: BGProcessLinkType.Href,
        value: {
          url: Routes.WidgetEdit,
          pathParams: {
            widgetId: jobResult.id,
          },
        },
      };
    case JobResultType.Reports:
      return {
        label: 'Download Report',
        type: BGProcessLinkType.Download,
        value: jobResult.url,
        fileName: getFileNameFromUrl(jobResult.url),
      };

    case JobResultType.HealthCheck:
      return {
        label: 'Download Health Check Report',
        type: BGProcessLinkType.Download,
        value: jobResult.url,
        fileName: getFileNameFromUrl(jobResult.url),
      };
  }
}

export default getJobLink;
